import { Children, ReactNode } from 'react';

export function useSlot<TSlot> (children: ReactNode, slotType: TSlot): ReactNode {
    let targetChild: ReactNode = undefined;

    Children.forEach(children, (child: ReactNode): void => {
        if (typeof child === 'boolean' || typeof child === 'number' || typeof child === 'string') {
            return;
        }

        if ((child as any)?.type?.ozSlot === slotType) {
            targetChild = child;
        }
    });

    return targetChild;
}
